.main {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.content {
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
